function initAutoSlides() {
  document.querySelectorAll('[data-auto-slide]').forEach(function (el) {
    var delay = (parseInt(el.dataset.autoplayDelay) || 3) * 1000;
    var paginationEl = el.querySelector('.auto-slide__pagination');

    new Swiper(el, {
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: delay,
        disableOnInteraction: false,
      },
      loop: true,
      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: true,
          }
        : false,
    });
  });
}

document.addEventListener('DOMContentLoaded', initAutoSlides);
